import '../../styles/style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useState, useEffect } from 'react';
import HeaderBar from './HeaderBar';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { useData, usePunishments } from './MemberData';
import Backdrop from '@mui/material/Backdrop';
import { Checkbox, CheckboxProps, styled } from "@mui/material";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { JSX } from "react/jsx-runtime";

import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'js-cookie';
import axios from 'axios';

let myDiscordID = ''

interface Member {
  user_id: number;
  full_name: string;
  callsign: number;
  entry_date: string | Date;
  last_up: string | Date;
  discordID: string;
  functions?: Record<string, boolean | string>;
  certificates?: Record<string, boolean | string>;
  fw: number;
  notes: string;
  grade: string;
  adminLevel: number;
  reintegrated: boolean;
}

const API_URL = 'http://panelpolitie.fplayt.ro:5001';

const refreshAccessToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/api/token`, {
      refreshToken: localStorage.getItem("refreshToken")
    });
    const { accessToken } = response.data;
    localStorage.setItem("token", accessToken);
    return accessToken;
  } catch (error) {
    throw new Error("Unable to refresh token");
  }
};

const makeAuthenticatedRequest = async (url: string, data: any) => {
  try {
    const token = localStorage.getItem("token");
    return await axios.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  } catch (err: any) {
    if (err.response.status === 403 || err.response.data?.error === "Invalid token") {
      try {
        const newToken = await refreshAccessToken();
        return await axios.post(url, data, {
          headers: {
            Authorization: `Bearer ${newToken}`
          }
        });
      } catch (refreshError) {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        throw new Error("Session expired. Please log in again.");
      }
    } else {
      throw err;
    }
  }
};

function MembersPage() {
  const { membersPunishments } = usePunishments();
  const { policeMembersData, academieMembersData, getPenDiscordMemberInfo, getDiscordIDType, getPoliceDiscordMemberInfo, penitenciarMembersData, fetchData, getAcademieMemberInfo, allMembersData, getPoliceMemberInfo, getPenMemberInfo } = useData();
  const [searchTerm, setSearchTerm] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedMemberData, setSelectedMemberData] = useState<Member | undefined>(undefined);
  const [isEditing, setIsEditing] = useState(false);
  const [isHR, setIsHR] = useState(false);
  const [isConducere, setIsConducere] = useState(false);
  const [upCallsign, setUPCallsign] = useState("");
  const [upModalOpen, setUpModalOpen] = useState(false);
  const [upAPSModalOpen, setUpAPSModalOpen] = useState(false);
  const [downAPModalOpen, setDownAPModalOpen] = useState(false);
  const [upDirectorModalOpen, setUpDirectorModalOpen] = useState(false);
  const [academieModalOpen, SetAcademieModalOpen] = useState(false);
  const [downCallsign, setDOWNCallsign] = useState("")
  const [downModalOpen, setDownModalOpen] = useState(false);
  const [oldCallsignModal, setOldCallsign] = useState("");
  const [newCallsignModal, setNewCallsign] = useState("");
  const [changeCallsignOpen, setOpenChangeCallsignModal] = useState(false);
  const [changeGradeOpen, openChangeGradeModal] = useState(false);
  const [newGrade, setNewGrade] = useState("");
  const [modalFWDays, setFWDays] = useState("");
  const [modalFWInput, setFWInput] = useState("");
  const [fwModalOpen, setFWModalOpen] = useState(false);
  const [fineModalOpen, setFineModalOpen] = useState(false);
  const [fineReason, setFineReason] = useState("");
  const [fineAmount, setFineAmount] = useState("");
  const [OpenDemiteModal, setDemitereModalOpen] = useState(false);
  const [demiteCallsign, setDemiteCallsign] = useState("");
  const [demiteDays, setDemiteDays] = useState("");
  const [functiiShow, setFunctiiShow] = useState("PD");
  const [memberPage, setMemberPage] = useState("PD");
  const [membersToFilter, setMembersToFilter] = useState<Member[]>([]);
  const [demitereType, setDemitereType] = useState("");
  const [ACadetModalOpen, setACadetModalOpen] = useState(false);
  const [cooldownModalOpen, setCooldownModalOpen] = useState(false);
  const [adminModal, openAdminModal] = useState(false);
  const [changeRankType, setChangeRankType] = useState("pol");
  const [penModalOpen, setPenModalOpen] = useState(false);
  const [penID, setPenID] = useState("");
  const [cooldownType, setCooldownType] = useState("");
  const [cooldownDays, setCooldownDays] = useState("");

  useEffect(() => {
    let isHRTemp = false;
    let isConducereTemp = false;
    myDiscordID = Cookies.get('myDiscordID') || '';

    for (let index = 0; index < allMembersData.length; index++) {
      const member = allMembersData[index];
      if (member.discordID === myDiscordID && (member.grade.toUpperCase() === "SUB-COMISAR" || member.grade.toUpperCase() === "COMISAR" || member.grade.toUpperCase() === "COMISAR-SEF" || member.grade.toUpperCase() === "CHESTOR-GENERAL")) {
        isConducereTemp = true;
      }
      if (member.discordID === myDiscordID) {
        if (member.functions?.['resurse umane'] === true || typeof member.functions?.['resurse umane'] === "string") {
          isHRTemp = true;
        }
      }
    }

    setMembersToFilter(policeMembersData);
    setIsHR(isHRTemp);
    setIsConducere(isConducereTemp);
  }, [allMembersData, policeMembersData]);

  const handleOpen = (mDiscordID: string, menuType: string) => {
    const memberData = allMembersData.find((member) => member.discordID === mDiscordID);
    if (memberData?.grade === "Agent-Paza" || memberData?.grade === "Agent-Paza-Sef" || memberData?.grade === "Director-Penitenciar") {
      menuType = "PEN";
    }
    if (memberData) {
      setSelectedMemberData(memberData);
    }
    setFunctiiCertificateOpen(true, menuType);
  };

  const setFunctiiCertificateOpen = (bool: any, menuType: string) => {
    setFunctiiShow(menuType);
    setOpen(Boolean(bool));
  }

  const handleClose = () => {
    setIsEditing(false);
    setOpen(false)
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: '65%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: 'black',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 4,
  };

  const upDownStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '25%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const fwStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const changeCallsignStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '32%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const demisieStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  const cooldownStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    height: '37%',
    display: 'flex',
    flexDirection: 'column',
    gap: '2%',
    bgcolor: '#191919',
    boxShadow: 24,
    borderRadius: '.3vw',
    outline: 'none',
    p: 2,
  }

  function validateString(input: string | null) {
    if (!input) return false;
    if (/[^0-9]/.test(input)) return false;
    if (input.startsWith('-')) return false;
    if (input.length > 3) return false;
    return true;
  }

  const handleSetMemberPage = (type: string) => {
    if (type === "PD") {
      setMembersToFilter(policeMembersData)
      setMemberPage("PD");
    } else {
      setMembersToFilter(penitenciarMembersData)
      setMemberPage("PEN");
    }
  }

  let filteredMembers = membersToFilter
  .filter((member) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      member.full_name.toLowerCase().includes(searchLower) ||
      String(member.callsign).padStart(3, '0').includes(searchLower) ||
      String(member.user_id).includes(searchLower)
    );
  })
  .sort((a, b) => a.callsign - b.callsign); 

  const toggleEditMode = async (type: string) => {
    if (isEditing === true && open === true) {
      try {
        await makeAuthenticatedRequest(`${API_URL}/api/update-member`, {
          memberData: selectedMemberData,
          type: type
        });
        fetchData();
        toast.success("Ai salvat modificările!")
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Modificările nu au fost salvate.")
        }
      }
    }
    setIsEditing(!isEditing);
  };

  const handleToggleFunction = (key: string, newValue: boolean | string) => {
    if (!selectedMemberData) return;
  
    const functions =
      typeof selectedMemberData.functions === "string"
        ? JSON.parse(selectedMemberData.functions)
        : selectedMemberData.functions;
  
    const updatedFunctions = {
      ...functions,
      [key]: newValue,
    };
  
    setSelectedMemberData({
      ...selectedMemberData,
      functions: updatedFunctions,
    });
  };

  const handleToggleCertificate = (key: string, newValue: boolean | string) => {
    if (!selectedMemberData) return;
  
    const certificates =
      typeof selectedMemberData.certificates === "string"
        ? JSON.parse(selectedMemberData.certificates)
        : selectedMemberData.certificates;
  
    const updatedCertificates = {
      ...certificates,
      [key]: newValue,
    };
  
    setSelectedMemberData({
      ...selectedMemberData,
      certificates: updatedCertificates,
    });
  };

  const handleOpenFWModal = () => {
    setFWModalOpen(true);
  }

  const handleFWClose = () => {
    setFWInput("");
    setFWModalOpen(false);
  }

  async function giveFW() {
    let type;
    if (selectedMemberData?.grade === "AGENT-PAZA" || selectedMemberData?.grade === "AGENT-PAZA-SEF" || selectedMemberData?.grade === "DIRECTOR-PENITENCIAR") {
      type = "pen";
    } else {
      type = "pol";
    }
    let userInput = modalFWDays;
    let reasonInput = modalFWInput;
    if (userInput === "-1" || Number(userInput) !== 0) {
      if (reasonInput) {
        try {
          await makeAuthenticatedRequest(`${API_URL}/api/give-fw`, {
            pType: "FW",
            reason: reasonInput,
            fullName: type === "pol" ? getPoliceMemberInfo(Number(selectedMemberData?.callsign), "full_name") : getPenMemberInfo(Number(selectedMemberData?.callsign), "full_name"),
            hr: `[${getPoliceDiscordMemberInfo(myDiscordID, "callsign").toString().padStart(3, '0')}]`,
            callsign: selectedMemberData?.callsign,
            type: type,
            status: false,
            userDiscordID: selectedMemberData?.discordID,
            hrDiscordID: myDiscordID,
            daysExpire: userInput
          });
          setFWInput("");
          setFWDays("");
          setFWModalOpen(false);
          toast.success("Ai acordat un FW cu succes!");

        } catch (err: any) {
          if (err.response.data.error === "Invalid token") {
            toast.error("Token invalid! Te rugăm să te reconectezi.");
            localStorage.removeItem("token");
          } else {
            toast.error("A apărut o eroare! FW-ul nu a fost acordat.");
          }
        }
      } else {
        toast.error("Motiv invalid!");
        return;
      }
    } else {
      toast.error("Zilele nu sunt valide!");
      return;
    }
  }

  function validateMoneyString(input: string | null) {
    if (!input) return false;

    if (/[^0-9]/.test(input)) return false;

    if (input.startsWith('-')) return false;


    return true;
  }

  const handleFineClose = () => {
    setFineReason("");
    setFineAmount("");
    setFineModalOpen(false);
  }

  const handleOpenFineModal = () => {
    setFineModalOpen(true);
  }

  async function giveFine() {
    let userInput = fineReason;
    let amountInput = fineAmount;
    if (userInput !== null) {
      try {
        if (validateMoneyString(amountInput) === false) {
          toast.error("Valoarea amenzii este invalidă!");
          return;
        }
        if (!amountInput) {
          toast.error("Valoare invalidă!");
          return;
        } else {
          const callsign = selectedMemberData?.callsign?.toString().padStart(3, '0');
          if (!callsign) {
            toast.error("Callsign-ul nu este valid.");
            return;
          }
          let memberName;
          if (selectedMemberData) {
            memberName = getDiscordIDType(selectedMemberData.discordID) === "pol" ? getPoliceMemberInfo(Number(selectedMemberData?.callsign), "full_name") : getPenMemberInfo(Number(selectedMemberData?.callsign), "full_name")
            if (!memberName) {
              toast.error("Numele membrului nu a fost găsit.");
              return;
            }
            if (selectedMemberData) {
              await makeAuthenticatedRequest(`${API_URL}/api/give-fine`, {
                pType: "AMENDA",
                reason: userInput,
                userDiscordID: selectedMemberData.discordID,
                hrDiscordID: myDiscordID,
                fullName: getDiscordIDType(selectedMemberData.discordID) === "pol" ? getPoliceMemberInfo(selectedMemberData.callsign, "full_name") : getPenMemberInfo(selectedMemberData.callsign, "full_name"),
                amount: amountInput,
                hr: `[${getDiscordIDType(selectedMemberData.discordID) === "pol" ? getPoliceDiscordMemberInfo(myDiscordID, "callsign").toString().padStart(3, '0') : `P-${getPenMemberInfo(Number(selectedMemberData?.callsign), "callsign").toString().padStart(2, '0')}`}]`,
                callsign: callsign,
                type: getDiscordIDType(selectedMemberData.discordID),
              });
            }
          }
          const messagePayload = {
            username: 'HR Politie',
            embeds: [
              {
                title: 'LOGS AMENDĂ',
                color: 0xff0000,
                fields: [
                  { name: 'HR', value: `**<@${myDiscordID}>**`, inline: true },
                  { name: 'Callsign+Nume', value: `[${callsign}] ${memberName}`, inline: true },
                  { name: 'Motiv', value: userInput, inline: true },
                  { name: 'Sumă', value: amountInput, inline: true },
                ],
              },
            ],
          };

          const webhookResponse = await fetch('https://discord.com/api/webhooks/1350143012310749296/g6I7NKJKGWfC7G7XUzP2hZBnBk-xOD1iRJun6LYpHUTMXeuT1e-5MKX8_mx1V9jas1NL', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(messagePayload),
          });

          if (webhookResponse.ok) {
            handleFineClose();
            toast.success(`Ai acordat o AMENDA lui [${callsign}] cu motivul: ${userInput}`);
          } else {
            console.error('Failed to send Discord message:', webhookResponse.statusText);
            toast.error('Nu s-a putut trimite log-ul pe Discord.');
          }
        }
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Amenda-ul nu a fost acordata.");
        }
      }
    } else {
      toast.success("Ai anulat acțiunea de Amenda!");
    }
  }

  const openChangeCallsignModal = async () => {
    setOpenChangeCallsignModal(true);
  }

  const changeCallsign = async () => {
    let oldCallsign = oldCallsignModal;
    let newCallsign = newCallsignModal;
    if (oldCallsign !== null) {
      if (validateString(newCallsign) === false) {
        toast.error("Callsign nou invalid!");
        return;
      }
      if (newCallsign !== null) {
        let findMember = policeMembersData.find((m) => m.callsign === Number(oldCallsign));
        if (findMember) {
          let checkCallsign = policeMembersData.find((m) => m.callsign === Number(newCallsign));
          if (checkCallsign) {
            toast.error("Exista un membru care are noul callsign deja!")
            return;
          } else {
            let content = `<@${getPoliceMemberInfo(findMember.callsign, "discordID")}> - Salutare, callsign-ul tău a fost modificat cu succes. Noul tău callsign este: **${String(newCallsign).padStart(3, '0')}**`
            
            const response = await makeAuthenticatedRequest(`${API_URL}/member/changeCallsign`, {
              oldCallsign: findMember.callsign,
              newCallsign: Number(newCallsign),
              content: content,
              hrDiscordID: myDiscordID
            })

            if (response.statusText === "OK") {
              fetchData();
              setOldCallsign("");
              setNewCallsign("");
              setOpenChangeCallsignModal(false);
              toast.success("Callsign modificat cu succes!")
            } else {
              toast.error("A apărut o eroare! Callsign-ul nu a fost modificat.")
            }
          }
        } else {
          toast.error("Nu există niciun polițist cu acest callsign!");
          return;
        }
      } else {
        toast.error("Callsign invalid!");
        return;
      }
    } else {
      toast.error("Callsign invalid!");
      return;
    }
  }

  const changeGrade = async () => {
    let grad = newGrade.toUpperCase();
    try {
      let findMember = policeMembersData.find((m) => m.callsign === Number(oldCallsignModal));
      if (findMember) {
        await makeAuthenticatedRequest(`${API_URL}/member/changeGrade`, {
          callsign: findMember.callsign,
          oldGrade: getPoliceMemberInfo(findMember.callsign, "grade"),
          newGrade: grad,
          hrDiscordID: myDiscordID
        })
        toast.success("Gradul a fost modificat cu succes!");
        openChangeGradeModal(false);
        fetchData();
      } else {
        toast.error("Nu există niciun membru cu acest callsign!");
        return;
      }
    } catch (err: any) {
      if (err.response.data.error === "Invalid token") {
        toast.error("Token invalid! Te rugăm să te reconectezi.");
        localStorage.removeItem("token");
      } else {
        toast.error("A apărut o eroare! Gradul nu a fost modificat.");
      }
    }
  }

  const checkPunishments = (sCallsign: number, discordID: string | undefined) => {
    let totalFW = 0;
    let fwActive = 0;
    let totalFines = 0;
    let finesActive = 0;
    let sType = getDiscordIDType(discordID || "");
    for (let index = 0; index < membersPunishments.length; index++) {
      const element = membersPunishments[index];
      const punishmentsTable = JSON.parse(element.punishments);
      if (Number(element.callsign) === sCallsign && element.type === sType) {
        if (element.pType === "fine") {
          totalFines++;
        } else {
          totalFW++;
        }
        if (element.pType === "fine" && punishmentsTable.status === false) {
          finesActive++;
        }
        if (element.pType === "fw" && punishmentsTable.status === false) {
          fwActive++;
        }
      }
    }
    toast((t) => (
      <span>
        Amenzi totale: <b>{totalFines}</b><br />Amenzi active: <b>{finesActive}</b><br />FW-uri totale: <b>{totalFW}</b><br />FW-uri active: <b>{fwActive}</b>
      </span>
    ));
  }

  const getNextCallsign = (db: any, callsignType: number) => {
    const existingCallsigns = db.map((item: { callsign: any; }) => item.callsign).sort((a: number, b: number) => a - b);

    const unavailableBases = [500, 400, 300, 200, 100];

    if (unavailableBases.includes(callsignType)) {
      callsignType++;
    }

    let nextCallsign = callsignType;

    while (existingCallsigns.includes(nextCallsign) || unavailableBases.includes(nextCallsign)) {
      nextCallsign++;
    }

    return nextCallsign;
  };

  const getCurrentDateInRomania = (): string => {
    const romaniaTime = new Date().toLocaleString("en-US", {
      timeZone: "Europe/Bucharest",
    });
    const date = new Date(romaniaTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const openUpMemberModal = async () => {
    setUpModalOpen(true);
  }

  const upPen = async (minCallsign: number, grade: string) => {
    let newCallsign;
    let content;
    let body;
    let rank;
    if (upCallsign) {
      let user_id = getPenMemberInfo(Number(upCallsign), "user_id");
      newCallsign = getNextCallsign(penitenciarMembersData, minCallsign);
      if (Number(upCallsign) < newCallsign) {
        content = `Salut <@${getPenMemberInfo(Number(upCallsign), "discordID")}>, din pacate ai primit **down** si CallSign-ul **P-${String(newCallsign).padStart(2, '0')}**. Nu te demoraliza! Poți face o solicitare pentru un Ticket de tip **ADD-GROUP**. Nu uita să iți schimbi porecla de pe aplicatie cu noul CallSign :partying_face: .`
      } else {
        content = `Felicitări <@${getPenMemberInfo(Number(upCallsign), "discordID")}> pentru **up**, ai primit CallSign-ul **P-${String(newCallsign).padStart(2, '0')}**. Toată munca ta nu a fost in zadar. Poți face o solicitare pentru un Ticket de tip **ADD-GROUP**. Nu uita să iți schimbi porecla de pe aplicatie cu noul CallSign :partying_face: .`
      }
      body = {
        content
      }
      const payload = {
        embeds: [
            {
              title: "CERERE GRAD POLITIE",
              fields: [
                { name: 'HR', value: `**<@${myDiscordID}>**`, inline: false },
                { name: 'Tip', value: `**ADAUGARE**`, inline: false },
                { name: 'Grad', value: `**${grade}**`, inline: false },
                { name: 'ID', value: `**${user_id}**`, inline: false },
              ],
              color: 0x3498db,
            },
        ],
      };

      const response = await makeAuthenticatedRequest(`${API_URL}/member/upPen`, {
        newCallsign: newCallsign, 
        rank: rank, 
        grade: grade, 
        last_up: getCurrentDateInRomania(),
        oldCallsign: Number(upCallsign),
        body: body,
        payload: payload,
        name: getPenMemberInfo(Number(upCallsign), "full_name"),
        hrDiscordID: myDiscordID
      })

      if (response.statusText === "OK") {
        fetchData();
        setUpModalOpen(false);
        toast.success("Up-ul a fost acordat cu succes!");
      } else {
        toast.error("A apărut o eroare! UP-ul nu a fost acordat.")
      }
    }
  }

  const upMember = async () => {
    let newCallsign;
    let content;
    let body;
    let grade;
    if (upCallsign) {
      let user_id = getPoliceMemberInfo(Number(upCallsign), "user_id");
      let actualGrade = getPoliceMemberInfo(Number(upCallsign), "grade");
      if (Number(upCallsign) > 500 && actualGrade === "CADET") {
        newCallsign = getNextCallsign(policeMembersData, 400);
        grade = "AGENT";
      } else if (Number(upCallsign) > 400 && actualGrade === "AGENT") {
        newCallsign = getNextCallsign(policeMembersData, 300);
        grade = "AGENT-PRINCIPAL";
      } else if (Number(upCallsign) > 300 && actualGrade === "AGENT-PRINCIPAL") {
        newCallsign = getNextCallsign(policeMembersData, 200);
        grade = "AGENT-SEF-PRINCIPAL";
      } else if (Number(upCallsign) > 200 && actualGrade === "AGENT-SEF-PRINCIPAL") {
        newCallsign = getNextCallsign(policeMembersData, 100);
        grade = "INSPECTOR";
      } else if (Number(upCallsign) > 100 && Number(upCallsign) < 200 && (actualGrade === "SUB-INSPECTOR" || actualGrade === "INSPECTOR" || actualGrade === "INSPECTOR-PRINCIPAL")) {
        newCallsign = getNextCallsign(policeMembersData, 7);
        grade = "SUB-COMISAR";
      } else if (Number(upCallsign) > 6 && Number(upCallsign) < 100 && actualGrade === "SUB-COMISAR") {
        newCallsign = getNextCallsign(policeMembersData, 4);
        grade = "COMISAR";
      } else if (Number(upCallsign) > 3 && Number(upCallsign) < 7 && actualGrade === "COMISAR") {
        newCallsign = getNextCallsign(policeMembersData, 2);
        grade = "COMISAR-SEF";
      } else if (Number(upCallsign) < 4 && actualGrade === "COMISAR-SEF") {
        newCallsign = getNextCallsign(policeMembersData, 1);
        grade = "CHESTOR-GENERAL";
      } else if (Number(upCallsign) < 2 && actualGrade === "CHESTOR-GENERAL") {
        toast.error("Nu poti da up la un Chestor-General!");
        return;
      } else {
        toast.error("Gradul nu corespunde cu callsign-ul!");
        return;
      }

      content = `<@${getPoliceMemberInfo(Number(upCallsign), "discordID")}> - Felicitari, conducerea Departamentului de Poliţie Los Santos a hotărât să te promoveze, noul tău callsign va fi **${String(newCallsign).padStart(3, '0')}**, poţi face in-game ticket de ADD-GROUP şi să-ţi modifici numele pe discord în funcţie de callsign-ul prezentat anterior.`
      body = {
        content
      }

      const payload = {
        embeds: [
          {
            title: "CERERE GRAD POLITIE",
            fields: [
              { name: 'HR', value: `**<@${myDiscordID}>**`, inline: false },
              { name: 'Tip', value: `**ADAUGARE**`, inline: false },
              { name: 'Grad', value: `**${grade}**`, inline: false },
              { name: 'ID', value: `**${user_id}**`, inline: false },
            ],
            color: 0x3498db,
          },
        ],
    };
      const response = await makeAuthenticatedRequest(`${API_URL}/member/updown`, {
        newCallsign: newCallsign, 
        grade: grade, 
        last_up: getCurrentDateInRomania(),
        oldCallsign: Number(upCallsign),
        payload: payload,
        body: body,
        name: getPoliceMemberInfo(Number(upCallsign), "full_name"),
        hrDiscordID: myDiscordID
      })

      if (response.statusText !== "OK") {
        toast.error("A apărut o eroare! UP-ul nu a fost acordat.")
      } else {
        fetchData();
        setUpModalOpen(false);
        toast.success("Up-ul a fost acordat cu succes!");
      }
    } else {
      toast.error("Ai anulat acțiunea de UP!")
    }
  }

  const downMember = async () => {
    let newCallsign;
    let content;
    let body;
    let grade;
    if (downCallsign) {
      let user_id = getPoliceMemberInfo(Number(downCallsign), "user_id");
      let actualGrade = getPoliceMemberInfo(Number(downCallsign), "grade");
      if (Number(downCallsign) < 2 && actualGrade === "CHESTOR-GENERAL") {
        newCallsign = getNextCallsign(policeMembersData, 2);
        grade = "COMISAR-SEF";
      } else if (Number(downCallsign) < 4 && actualGrade === "COMISAR-SEF") {
        newCallsign = getNextCallsign(policeMembersData, 4);
        grade = "COMISAR";
      } else if (Number(downCallsign) < 7 && actualGrade === "COMISAR") {
        newCallsign = getNextCallsign(policeMembersData, 7);
        grade = "SUB-COMISAR";
      } else if (Number(downCallsign) < 100 && actualGrade === "SUB-COMISAR") {
        newCallsign = getNextCallsign(policeMembersData, 100);
        grade = "INSPECTOR";
      } else if ((Number(downCallsign) < 200 && Number(downCallsign) > 100) && (actualGrade === "SUB-INSPECTOR" || actualGrade === "INSPECTOR" || actualGrade === "INSPECTOR-PRINCIPAL")) {
        newCallsign = getNextCallsign(policeMembersData, 200);
        grade = "AGENT-SEF-PRINCIPAL";
      } else if ((Number(downCallsign) < 300 && Number(downCallsign) > 200) && actualGrade === "AGENT-SEF-PRINCIPAL") {
        newCallsign = getNextCallsign(policeMembersData, 300);
        grade = "AGENT-PRINCIPAL";
      } else if ((Number(downCallsign) < 400 && Number(downCallsign) > 300) && actualGrade === "AGENT-PRINCIPAL") {
        newCallsign = getNextCallsign(policeMembersData, 400);
        grade = "AGENT";
      } else if ((Number(downCallsign) < 500 && Number(downCallsign) > 400) && actualGrade === "AGENT") {
        newCallsign = getNextCallsign(policeMembersData, 500);
        grade = "CADET";
      } else if ((Number(downCallsign) < 600 && Number(downCallsign) > 500) && actualGrade === "CADET") {
        toast.error("Nu poti da down la un cadet!");
        return;
      } else {
        toast.error("Gradul nu corespunde cu callsign-ul!");
        return;
      }

      content = `<@${getPoliceMemberInfo(Number(downCallsign), "discordID")}> - Din pacate, conducerea Departamentului de Poliţie Los Santos a hotărât să te retrogradeze, noul tău callsign va fi **${String(newCallsign).padStart(3, '0')}**, poţi face ticket in-game de ADD-GROUP şi să-ţi modifici numele pe discord în funcţie de callsign-ul prezentat anterior.`
      body = {
        content
      }
      const payload = {
        embeds: [
          {
            title: "CERERE GRAD POLITIE",
            fields: [
              { name: 'HR', value: `**<@${myDiscordID}>**`, inline: false },
              { name: 'Tip', value: `**ADAUGARE**`, inline: false },
              { name: 'Grad', value: `**${grade}**`, inline: false },
              { name: 'ID', value: `**${user_id}**`, inline: false },
            ],
            color: 0x3498db,
          },
        ],
    };

      const response = await makeAuthenticatedRequest(`${API_URL}/member/updown`, {
        newCallsign: newCallsign, 
        grade: grade, 
        last_up: getCurrentDateInRomania(),
        oldCallsign: Number(downCallsign),
        payload: payload,
        body: body,
        name: getPoliceMemberInfo(Number(downCallsign), "full_name"),
        hrDiscordID: myDiscordID
      })

      if (response.statusText === "OK") {
        fetchData();
        setDownModalOpen(false);
        toast.success("Down-ul a fost acordat cu succes!");
      } else {
        toast.error("A apărut o eroare! DOWN-ul nu a fost acordat.")
      }
    } else {
      toast.error("Ai anulat acțiunea de DOWN!")
    }
  }

  const formatDate = (date: string | Date): string => {
    if (date === null) {
      return 'N/A';
    }
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const openDownMemberModal = async () => {
    setDownModalOpen(true);
  }
  
  const handleDemitereClose = () => {
    setDemiteCallsign("");
    setDemitereModalOpen(false);
  }

  const handleOpenOutMember = (type: string) => {
    setDemitereType(type);
    setDemitereModalOpen(true);
  }

  const outMember = async () => {
    handleDemitereClose();
    let content = `Salut <@${demitereType === "pol" ? getPoliceMemberInfo(Number(demiteCallsign), "discordID") : getPenMemberInfo(Number(demiteCallsign), "discordID")}> - Conducerea departamentului de poliţie Los Santos a decis să fi demis din cadrul departamentului, poţi face ticket de ADD-GROUP pentru scoaterea gradelor şi să părăseşti server-ul de discord.`
    let content2;
    if (Number(demiteDays) < 30) {
      content2 = `+ <@&1346923860234207232> Ban ${demiteDays}d (**Eșuarea de a sta intr-o facțiune legala**)`
    } else if (Number(demiteDays) === 30) {
      content2 = `+ <@&1346923860234207232> Ban ${demiteDays}d (**Coruptie**)`
    }
    if (Number(demiteDays) === 0) {
      content2 = null;
    }
    const payload = {
      content: content2,
      embeds: [
        {
          title: "CERERE GRAD POLITIE",
          fields: [
            { name: 'HR', value: `<@${myDiscordID}>`, inline: false },
            { name: 'Tip', value: `**SCOATERE**`, inline: false },
            { name: 'Grad', value: `**${demitereType === "pol" ? getPoliceMemberInfo(Number(demiteCallsign), 'grade').toUpperCase() : getPenMemberInfo(Number(demiteCallsign), 'grade').toUpperCase()}**`, inline: false },
            { name: 'ID', value: `**${demitereType === "pol" ? getPoliceMemberInfo(Number(demiteCallsign), 'user_id') : getPenMemberInfo(Number(demiteCallsign), 'user_id')}**`, inline: false },
          ],
          color: 0x3498db,
        },
      ],
    };

    try {
      try {
        const response = await makeAuthenticatedRequest(`${API_URL}/deleteMemberData`, {
          callsign: Number(demiteCallsign),
          type: demitereType,
          email: getPoliceMemberInfo(Number(demiteCallsign), "email"),
          content: content,
          payload: payload
        })
        if (response.statusText !== "OK") {
          toast.error("A apărut o eroare! Membrul nu a fost șters din baza de date!");
          return;
        }
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Membrul nu a fost șters din baza de date!");
        }
      }

      const now = new Date();

      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0'); 
      const year = now.getFullYear();
  
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
  
      try {
        content = `**DEMITERE ${demitereType.toUpperCase()}**\nCallsign: **${demitereType === "pol" ? String(demiteCallsign).padStart(3, '0') : `P-${String(demiteCallsign).padStart(2, '0')}`}**\nNume: **${demitereType === "pol" ? getPoliceMemberInfo(Number(demiteCallsign), "full_name") : getPenMemberInfo(Number(demiteCallsign), "full_name")}**\nZile Ban: **${demiteDays}**\nHR: <@${myDiscordID}>`;
        const response = await makeAuthenticatedRequest(`${API_URL}/createHRLogs`, {
          type: "DEMITERE",
          memberName: `[${demitereType === "pol" ? String(Number(demiteCallsign)).padStart(3, '0') : `P-${String(Number(demiteCallsign)).padStart(3, '0')}`}] ${demitereType === "pol" ? getPoliceMemberInfo(Number(demiteCallsign), "full_name") : getPenMemberInfo(Number(demiteCallsign), "full_name")}`,
          date_time: `${day}.${month}.${year} - ${hours}:${minutes}`,
          pType: "",
          fromCS: "",
          cType: "",
          content: content
        })
        if (response.statusText === "OK") {
          fetchData();
          toast.success("DEMITERE efectuata cu succes!");
        } else {
          toast.error("A apărut o eroare! Demiterea nu a fost trecută în Istoric HR!")
          return;
        }
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Demiterea nu a fost trecută în Istoric HR!")
        }
      }
      return;
    } catch (error) {
      toast.error("A apărut o eroare! Demiterea nu a fost trecută în Istoric HR!")
      console.error('Error sending webhook:', error);
    }
  }

  const handleUpModalClose = () => {
    setUPCallsign('');
    setUpModalOpen(false);
    setUpAPSModalOpen(false);
    setUpDirectorModalOpen(false);
    setDownAPModalOpen(false);
    SetAcademieModalOpen(false);
    setACadetModalOpen(false);
  }

  const handleDownModalClose = () => {
    setDOWNCallsign('');
    setDownModalOpen(false);
  }

  const handleChangeCallsignModalClose = () => {
    setOldCallsign("");
    setNewCallsign("");
    setOpenChangeCallsignModal(false);
  }

  const checkAcademie = async () => {
    let list = [];
    let activity = await axios.get(`${API_URL}/activity/get`);
    try {
      if (penitenciarMembersData.length === 0) {
        toast.error("Nu exista membrii în penitenciar!");
        return;
      }
      for (let index = 0; index < penitenciarMembersData.length; index++) {
        const element = penitenciarMembersData[index];
        const dateToCompare = new Date(element.entry_date);
        const today = new Date();
        const diffInMs = today.getTime() - dateToCompare.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        
        if (element.certificates?.["instructaj"] && element.certificates?.["radio"] && element.certificates?.["transport detinuti"] && element.certificates?.["CTLS"]) {
          let activityData = activity.data.find((a: { callsign: number; type: string }) => a.callsign === element.callsign && a.type === "pen");
          list.push({
            callsign: element.callsign,
            days: diffInDays,
            activity: JSON.parse(activityData.weekly_report)
          })
        }
      }
      const group1 = list.filter(item => Number(item.callsign) <= 19);
      const group2 = list.filter(item => Number(item.callsign) >= 20);
      group1.sort((a, b) => b.days - a.days);
      group2.sort((a, b) => b.days - a.days);
      const sortedList = [...group1, ...group2];
      const message = sortedList
        .map(item => `CS: **P-${String(item.callsign).padStart(2, '0')}**, Zile: **${item.days}**, Activitate: **${item.activity[0] || 0}, ${item.activity[1] || 0}**`)
        .join("\n");
      
      await makeAuthenticatedRequest(`${API_URL}/academie/sendList`, {
        message: message
      })

      toast.success("Lista a fost trimisă pe discord!");
    } catch (err: any) {
      if (err.response.data.error === "Invalid token") {
        toast.error("Token invalid! Te rugăm să te reconectezi.");
        localStorage.removeItem("token");
      } else {
        toast.error("A apărut o eroare! Lista nu a fost trimisă.");
      }
    }
  }

  const sendAcademie = async () => {
    if (Number(upCallsign) > 0) {
      try {
        let message = `<@${getPenMemberInfo(Number(upCallsign), "discordID")}> - Felicitări, ai fost ales pentru academia de poliţie, te rugăm să îţi schimbi numele pe discord în [AC] <NUME-IC> iar noi îţi dorim mult succes!`
        await makeAuthenticatedRequest(`${API_URL}/penitenciar/academie`, {
          callsign: Number(upCallsign),
          id: getPenMemberInfo(Number(upCallsign), "user_id"),
          nume: getPenMemberInfo(Number(upCallsign), "full_name"),
          discordID: getPenMemberInfo(Number(upCallsign), "discordID"),
          entryDate: getPenMemberInfo(Number(upCallsign), "entry_date"),
          email: getPenMemberInfo(Number(upCallsign), "email"),
          message: message,
          hrDiscordID: myDiscordID
        })

        fetchData();
        toast.success("Membru trimis la academie cu succes!");
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Jucătorul nu a fost trimis la academie.")
        }
      }
    }
  }

  const upCadet = async () => {
    if (Number(upCallsign) > 0) {
      try {
        const newCallsign = getNextCallsign(policeMembersData, 500);
        let message = `<@${getAcademieMemberInfo(Number(upCallsign), "discordID")}> - Felicitari ai promovat la gradul de CADET! Ai primit CALL-SIGN **${newCallsign}**, poti face ticket de ADD-GROUP si sa iti schimbi numele si nu uita ca ai timp 7 zile sa obtii certificatele RADIO + MDT. Spor!`
        const payload = {
          embeds: [
            {
              title: "CERERE GRAD POLITIE",
              fields: [
                { name: 'HR', value: `<@${myDiscordID}>`, inline: false },
                { name: 'Tip', value: `**ADAUGARE**`, inline: false },
                { name: 'Grad', value: `**CADET**`, inline: false },
                { name: 'ID', value: `**${getAcademieMemberInfo(Number(upCallsign), 'user_id')}**`, inline: false },
              ],
              color: 0x3498db,
            },
          ],
        };

        await makeAuthenticatedRequest(`${API_URL}/academie/cadet`, {
          callsign: newCallsign,
          id: getAcademieMemberInfo(Number(upCallsign), "user_id"),
          nume: getAcademieMemberInfo(Number(upCallsign), "full_name"),
          discordID: getAcademieMemberInfo(Number(upCallsign), "discordID"),
          entryDate: getAcademieMemberInfo(Number(upCallsign), "entry_date"),
          email: getAcademieMemberInfo(Number(upCallsign), "email"),
          message: message,
          payload: payload,
          hrDiscordID: myDiscordID
        })

        fetchData();
        toast.success("Membru a primit up la cadet cu succes!");
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Membrul nu a fost promovat la CADET.")
        }
      }
    } else {
      toast.error("ID invalid!");
    }
  }

  const handleOpenCooldownModal = () => {
    setCooldownModalOpen(true);
  }

  const handleCooldownModalClose = () => {
    setCooldownModalOpen(false);
  }

  const changeAdminRank = async (type: string) => {
    if (oldCallsignModal && (Number(newGrade) > 0)) {
      try {
        await makeAuthenticatedRequest(`${API_URL}/setAdminRank`, {
          callsign: Number(oldCallsignModal),
          rank: Number(newGrade),
          tip: type,
          hrDiscordID: myDiscordID
        });

        handleAdminModalClose();
        fetchData();
        toast.success(`Jucatorului cu callsign ${type === "pol" ? oldCallsignModal.padStart(3, '0') : `P-${oldCallsignModal.padStart(2, '0')}`} i-a fost setat gradul de ADMIN ${newGrade}`);
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Polițistului nu i-a fost setat rank-ul de ADMIN.");
        }
      }
    } else {
      toast.error("Trebuie să completezi toate câmpurile!");
      return;
    }
  };


  const handleAdminModalClose = () => {
    openAdminModal(false);
    setOldCallsign("");
    setNewGrade("");
  }

  const [confiscatedCheck, setConfiscatedCheck] = useState(false);

  const handleChangeGradeClose = () => {
    openChangeGradeModal(false);
  }

  const renderMembers = (grade: string) => {
    let parsedCerts: Record<string, string | boolean> | null | undefined = null;
    return filteredMembers
      .filter((memberData) => {
        parsedCerts = memberData.certificates;
        return memberData.grade !== "ACADEMIE" && memberData.grade === grade;
      })
      .map((memberData, index) => (
        <div
          key={index}
          className="w-full min-h-[7%] flex items-center gap-[0.7vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]"
        >
          {memberData.reintegrated ? (
            <span className="textSemiBold w-[3%] text-center text-[0.8vw] text-[#ffffff]">
              RE: {memberData.user_id}
            </span>
          ) : (
            <span className="textSemiBold w-[3%] text-center text-[0.8vw] text-[#ffffff]">
              {memberData.user_id}
            </span>
          )}
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <span
            className={`textSemiBold w-[3.5%] text-center text-[0.8vw] ${
              memberData.adminLevel === 1
                ? "text-[#ffffff80]"
                : memberData.adminLevel === 2
                ? "text-green-500"
                : memberData.adminLevel === 3
                ? "text-blue-500"
                : memberData.adminLevel === 4
                ? "text-yellow-300"
                : memberData.adminLevel === 5
                ? "text-orange-500"
                : memberData.adminLevel === 6
                ? "text-red-500"
                : "text-[#ffffff]"
            }`}
          >
            {grade === "AGENT-PAZA" || grade === "AGENT-PAZA-SEF" || grade === "DIRECTOR-PENITENCIAR"
              ? `P-${String(memberData.callsign).padStart(2, "0")}`
              : String(memberData.callsign).padStart(3, "0")}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">
            {memberData.full_name}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">
            {memberData.grade}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <div className="w-[7%] h-full flex items-center justify-center">
            <div className="w-[90%] h-[60%] flex items-center justify-center bg-gradient-to-r from-[#25A138] to-[#18F51F] rounded-3xl">
              <span className="textSemiBold text-white text-[0.8vw]">ACTIV</span>
            </div>
          </div>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          {grade === "AGENT-PAZA" || grade === "AGENT-PAZA-SEF" || grade === "DIRECTOR-PENITENCIAR" ? (
            <>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['instructaj'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['radio'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['transport detinuti'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['CTLS'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
            </>
          ) : (
            <>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['radio'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['MDT'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['FT'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['pilot'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className="textSemiBold w-[2%] text-center text-[0.8vw] text-[#ffffff]">{parsedCerts?.['moto'] === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
              <span className={`textSemiBold w-[2%] text-center text-[0.8vw] ${parsedCerts?.['HS Incepator'] === true ? "text-green-500" : parsedCerts?.['HS Avansat'] === true ? "text-blue-500" : "text-[#ffffff]"}`}>{(parsedCerts?.['HS Incepator'] || parsedCerts?.['HS Avansat']) === true ? "DA" : "NU"}</span>
              <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
            </>
          )}
          <span
            className={`textSemiBold w-[2%] text-center text-[0.8vw] ${
              memberData.fw === 0
                ? "text-green-500"
                : memberData.fw === 1
                ? "text-orange-500"
                : "text-red-500"
            }`}
          >
            {memberData.fw}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <span className="textSemiBold w-[5%] text-center text-[0.8vw] text-[#ffffff]">
            {formatDate(memberData.entry_date)}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <span className="textSemiBold w-[5%] text-center text-[0.8vw] text-[#ffffff]">
            {formatDate(memberData.last_up)}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">
            {memberData.discordID}
          </span>
          <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
          <div
            onClick={() =>
              memberData.grade === "AGENT-PAZA" ||
              memberData.grade === "AGENT-PAZA-SEF" ||
              memberData.grade === "DIRECTOR-PENITENCIAR"
                ? handleOpen(memberData.discordID, "PEN")
                : handleOpen(memberData.discordID, "PD")
            }
            className="w-[7%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0FA2D8] to-[#1844F5]"
          >
            <span className="textBold text-white text-[.7vw]">GESTIONEAZĂ</span>
          </div>
        </div>
      ));
  };
  
  const handlePenModalClose = () => {
    setPenID("");
    setPenModalOpen(false);
  }

  const sendPen = async () => {
    if (penID) {
      try {
        await makeAuthenticatedRequest(`${API_URL}/penitenciar/sendPen`, {
          id: Number(penID),
          callsign: getNextCallsign(penitenciarMembersData, 20),
          nume: getAcademieMemberInfo(Number(penID), "full_name"),
          discordID: getAcademieMemberInfo(Number(penID), "discordID"),
          entryDate: getAcademieMemberInfo(Number(penID), "entry_date"),
          lastUp: getCurrentDateInRomania(),
          email: getAcademieMemberInfo(Number(penID), "email"),
          hrDiscordID: myDiscordID
        });
        toast.success("Membru trimis la penitenciar cu succes!");
        handlePenModalClose();
        fetchData();
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Membrul nu a fost trimis la penitenciar.");
        }
      }
    }
  }

  const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 23,
    height: 23,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
        ...theme.applyStyles('dark', {
        backgroundColor: '#30404d',
        }),
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
        ...theme.applyStyles('dark', {
        background: 'rgba(57,75,89,.5)',
        }),
    },
    ...theme.applyStyles('dark', {
        boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
        backgroundColor: '#394b59',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
    }),
  }));
  
  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#0077ff',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 23,
        height: 23,
        backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#0077ff',
    },
  });
  
  function BpCheckbox(props: JSX.IntrinsicAttributes & CheckboxProps) {
    return (
      <Checkbox
        sx={{ '&:hover': { bgcolor: 'transparent' } }}
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        inputProps={{ 'aria-label': 'Checkbox demo' }}
        {...props}
      />
    );
  }

  const setCooldown = async () => {
    if (Number(cooldownDays) > 0 && cooldownType && selectedMemberData) {
      try {
        await makeAuthenticatedRequest(`${API_URL}/setCooldown`, {
          callsign: Number(selectedMemberData?.callsign),
          days: cooldownDays,
          type: cooldownType,
          pType: getDiscordIDType(selectedMemberData.discordID),
          confiscated: confiscatedCheck
        })
        handleCooldownModalClose();
        fetchData();
        toast.success(`Membrului cu callsign ${String(selectedMemberData?.callsign).padStart(3, '0')} i-a fost setat cooldown-ul de ${cooldownDays} zile!`);
      } catch (err: any) {
        if (err.response.data.error === "Invalid token") {
          toast.error("Token invalid! Te rugăm să te reconectezi.");
          localStorage.removeItem("token");
        } else {
          toast.error("A apărut o eroare! Membrului nu i-a fost setat cooldown-ul.")
        }
      }
    }
  }

  return (
    <div className="w-full h-full flex flex-col">
      <HeaderBar currentPage="Membrii Departament"/>
      <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
        <div className="w-full h-[7%] flex items-center justify-between">
          <div className="w-[30%] h-full flex items-center justify-between">
            <span className="textSemiBold text-[1.1vw]  text-[#ffffff]">Membrii Departament</span>
            {memberPage === "PD" ? (
              <div onClick={() => handleSetMemberPage("PEN")} className="w-[50%] h-[80%] flex items-center justify-center bg-gradient-to-r from-[#319BC1] to-[#193989] rounded-[0.5vw] shadow-xl cursor-pointer">
                <span className="textSemiBold text-white text-[0.9vw]">Membrii Penitenciar</span>
              </div>
            ) : (
              <div onClick={() => handleSetMemberPage("PD")} className="w-[50%] h-[80%] flex items-center justify-center bg-gradient-to-r from-[#319BC1] to-[#193989] rounded-[0.5vw] shadow-xl cursor-pointer">
                <span className="textSemiBold text-white text-[0.9vw]">Membrii Poliție</span>
              </div>
            )}
          </div>
          {isConducere ? (
            memberPage === "PD" ? (
              <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
                <div onClick={() => setACadetModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">CADET</span>
                </div>
                <div onClick={openUpMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP</span>
                </div>
                <div onClick={openDownMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">DOWN</span>
                </div>
                <div onClick={openChangeCallsignModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">SCHIMBĂ CALLSIGN</span>
                </div>
                <div onClick={() => openChangeGradeModal(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">SCHIMBĂ GRAD</span>
                </div>
                <div onClick={() => {openAdminModal(true); setChangeRankType("pol");}}  className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">ADMIN</span>
                </div>
                <div onClick={() => setPenModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0f8bd8] to-[#1874f5]">
                  <span className="textBold text-white text-[.8vw]">PEN</span>
                </div>
                <div onClick={() => handleOpenOutMember("pol")} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                  <span className="textBold text-white text-[.8vw]">DEMITERE</span>
                </div>
              </div>
            ) : (
              <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
                <div onClick={() => setUpDirectorModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP DIRECTOR</span>
                </div>
                <div onClick={() => setUpAPSModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP APS</span>
                </div>
                <div onClick={() => setDownAPModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">DOWN AGENT-PAZA</span>
                </div>
                <div onClick={checkAcademie} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">LISTĂ ACADEMIE</span>
                </div>
                <div onClick={() => SetAcademieModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">ACADEMIE</span>
                </div>
                <div onClick={() => {openAdminModal(true); setChangeRankType("pen");}}  className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">ADMIN</span>
                </div>
                <div onClick={() => handleOpenOutMember("pen")} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                  <span className="textBold text-white text-[.8vw]">DEMITERE</span>
                </div>
              </div>
            )
          ) : isHR ? (
            memberPage === "PD" ? (
              <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
                <div onClick={() => setACadetModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">CADET</span>
                </div>
                <div onClick={openUpMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP</span>
                </div>
                <div onClick={openDownMemberModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">DOWN</span>
                </div>
                <div onClick={openChangeCallsignModal} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">SCHIMBĂ CALLSIGN</span>
                </div>
                <div onClick={() => openChangeGradeModal(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">SCHIMBĂ GRAD</span>
                </div>
                <div onClick={() => {openAdminModal(true); setChangeRankType("pol");}}  className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">ADMIN</span>
                </div>
                <div onClick={() => handleOpenOutMember("pol")} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                  <span className="textBold text-white text-[.8vw]">DEMITERE</span>
                </div>
              </div>
            ) : (
              <div className="w-[60%] h-full flex items-center justify-center gap-[1%]">
                <div onClick={() => setUpDirectorModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP DIRECTOR</span>
                </div>
                <div onClick={() => setUpAPSModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">UP APS</span>
                </div>
                <div onClick={() => setDownAPModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">DOWN AGENT-PAZA</span>
                </div>
                <div onClick={() => SetAcademieModalOpen(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                  <span className="textBold text-white text-[.8vw]">ACADEMIE</span>
                </div>
                <div onClick={() => handleOpenOutMember("pen")} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#d80f0f] to-[#f51818]">
                  <span className="textBold text-white text-[.8vw]">DEMITERE</span>
                </div>
              </div>
            )
          ) : (
            <div></div>
          )}
          <div className=" bg-[#ffffff10] border  border-[#ffffff20] w-[15%] h-[90%] rounded-full flex items-center justify-between box-border px-[1%]">
            <input
              type="text"
              placeholder="Caută un politist"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pb-[1%]   text-[#ffffff50] placeholder-[#ffffff50] placeholder:text-[0.8vw] text-[0.8vw] bg-transparent h-full border-none outline-none"
            />
            <FontAwesomeIcon className="  text-[#ffffff50] text-[0.8vw]" icon={faMagnifyingGlass} />
          </div>
        </div>
        <div className=" bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
          <div className="w-full min-h-[7%] flex items-center gap-[0.7vw] box-border pl-[1%] pr-[1%] border-b-[3px] border-[#525252]">
            <span className="textBold text-center text-white text-[1vw] w-[3%]">
              ID
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[3.5%]">
              CS
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[10%]">
              NUME
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[10%]">
              GRAD
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[7%]">
              STATUS
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            {memberPage === "PD" ? (
              <>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  R
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  MDT
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  FT
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  P
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  M
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  HS
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              </>
            ) : (
              <>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  I
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  R
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  T
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                <span className="textBold text-center text-white text-[1vw] w-[2%]">
                  CT
                </span>
                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
              </>
            )}
            <span className="textBold text-center text-white text-[1vw] w-[2%]">
              FW
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[5%]">
              INTRARE
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[5%]">
              UP
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[10%]">
              DISCORD
            </span>
            <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
            <span className="textBold text-center text-white text-[1vw] w-[7%]">
              ACȚIUNI
            </span>
          </div>
          {memberPage === "PD" ? (
            <>
              {renderMembers("CHESTOR-GENERAL")}
              {renderMembers("COMISAR-SEF").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">COMISARI-ȘEFI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("COMISAR-SEF")}
                </>
              )}
              {renderMembers("COMISAR").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">COMISARI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("COMISAR")}
                </>
              )}
              {renderMembers("SUB-COMISAR").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">SUB-COMISARI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("SUB-COMISAR")}
                </>
              )}
              {renderMembers("INSPECTOR-PRINCIPAL").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">INSPECTORI-PRINCIPALI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("INSPECTOR-PRINCIPAL")}
                </>
              )}
              {renderMembers("INSPECTOR").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">INSPECTORI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("INSPECTOR")}
                </>
              )}
              {renderMembers("SUB-INSPECTOR").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">SUB-INSPECTORI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("SUB-INSPECTOR")}
                </>
              )}
              {renderMembers("AGENT-SEF-PRINCIPAL").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">AGENȚI-ȘEFI-PRINCIPALI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("AGENT-SEF-PRINCIPAL")}
                </>
              )}
              {renderMembers("AGENT-PRINCIPAL").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">AGENȚI-PRINCIPALI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("AGENT-PRINCIPAL")}
                </>
              )}
              {renderMembers("AGENT").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">AGENȚI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("AGENT")}
                </>
              )}
              {renderMembers("CADET").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">CADEȚI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("CADET")}
                </>
              )}
            </>
          ) : (
            <>
              {renderMembers("DIRECTOR-PENITENCIAR")}
              {renderMembers("AGENT-PAZA-SEF").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">AGENTI-PAZA-SEFI</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("AGENT-PAZA-SEF")}
                </>
              )}
              {renderMembers("AGENT-PAZA").length > 0 && (
                <>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">AGENTI-PAZA</span>
                  <div className="w-full min-h-[.7%] bg-[#525252]"></div>
                  {renderMembers("AGENT-PAZA")}
                </>
              )}
            </>
          )}
          {memberPage === "PD" && (
            <>
              <div className="w-full min-h-[.7%] bg-[#525252]"></div>
              <span className="w-full min-h-[8%] text-white textBold text-[1.2vw] flex items-center justify-center">MEMBRII ACADEMIE</span>
              <div className="w-full min-h-[.7%] bg-[#525252]"></div>
              {academieMembersData.map((memberData, index) => (
                <div key={index} className="w-full min-h-[7%] flex items-center gap-[0.9vw] box-border pl-[1%] pr-[1%] border-b-[1px] border-[#D0D0D0]">
                  {memberData.reintegrated ? (
                    <span className="textSemiBold w-[3%] text-center text-[0.8vw] text-[#ffffff]">RE: {memberData.user_id}</span>
                  ) : (
                    <span className="textSemiBold w-[3%] text-center text-[0.8vw] text-[#ffffff]">{memberData.user_id}</span>
                  )}
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span className="textSemiBold w-[3.5%] text-center text-[0.8vw] text-[#ffffff]">AC</span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">{memberData.full_name}</span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span className="textSemiBold w-[10%] text-center text-[0.8vw] text-[#ffffff]">{memberData.grade}</span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <div className="w-[7%] h-full flex items-center justify-center">
                    <div className="w-[90%] h-[60%] flex items-center justify-center bg-gradient-to-r from-[#25A138] to-[#18F51F] rounded-3xl">
                      <span className="textSemiBold text-white text-[0.8vw]">ACTIV</span>
                    </div>
                  </div>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <div onClick={() => handleOpen(memberData.discordID, "AC")} className="w-[13.5%] h-[70%] px-[0.5%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#0FA2D8] to-[#1844F5]">
                    <span className="textBold text-white text-[.7vw]">AFIȘEAZĂ CERTIFICATE</span>
                  </div>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span
                    className={`textSemiBold w-[0.8%] text-center text-[0.8vw] ${
                        memberData.fw === 0
                            ? 'text-green-500'
                            : memberData.fw === 1
                            ? 'text-orange-500'
                            : 'text-red-500'
                    }`}
                  >
                    {memberData.fw}
                  </span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span className="textSemiBold w-[11%] text-center text-[0.8vw] text-[#ffffff]">Dată Intrare: {formatDate(memberData.entry_date)}</span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span className="textSemiBold w-[11%] text-center text-[0.8vw] text-[#ffffff]">Ultimul UP: {formatDate(memberData.last_up)}</span>
                  <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#ffffff00] via-[#ffffff] to-[#ffffff00]"></div>
                  <span className="textSemiBold min-w-fit text-center text-[0.8vw] text-[#ffffff]">{memberData.discordID}</span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="flex flex-col">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">
            Informații - [
            {functiiShow === "PD"
              ? selectedMemberData?.callsign?.toString().padStart(3, '0') || 'N/A'
              : functiiShow === "PEN"
              ? `P-${selectedMemberData?.callsign?.toString().padStart(2, '0')}` || 'N/A'
              : "AC"}
            ] {selectedMemberData?.full_name}
          </span>
            <div className="w-[100%] h-[70%]  bg-[#282828] rounded-[0.5vw] flex items-center justify-center gap-[0.5%]">
              {(functiiShow === "PD" || functiiShow === "PEN") && (
                <>
                  <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                    <span className="textSemiBold text-[1.2vw] text-center  text-white">Atribuții</span>
                    <div className="w-full h-full flex flex-col text-base/3">
                      {policeMembersData && policeMembersData.length > 0 && selectedMemberData?.functions ? (
                        (() => {
                          const functions = typeof selectedMemberData.functions === 'string'
                            ? JSON.parse(selectedMemberData.functions) 
                            : selectedMemberData.functions; 

                          return Object.entries(functions).map(([key, value]) => (
                            <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                              <span className="textSemiBold text-[1vw]  text-white">
                                {key.charAt(0).toUpperCase() + key.slice(1)} 
                              </span>
                              <div className="flex items-center gap-[2%] justify-end w-[40%]">
                                {isEditing && (
                                  <div
                                    onClick={() => handleToggleFunction(key, !value)}
                                    className={`w-[1vw] h-[1vw] rounded-full box-border flex items-center justify-center pb-[5%] cursor-pointer ${
                                      value ? 'bg-red-500' : 'bg-green-500'
                                    } text-white`}
                                  >
                                    {value ? '-' : '+'}
                                  </div>
                                )}
                                <span className="textSemiBold text-[#0080D0] text-[1vw]">
                                  {typeof value === 'string' ? value : value ? 'DA' : 'NU'} 
                                </span>
                              </div>
                            </div>
                          ));
                        })()
                      ) : (
                        <div className="textMedium  text-white text-[1vw] w-full h-full flex items-center justify-center">
                          Nu ai nicio funcție atribuită.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-[1px] h-[90%] bg-[#929292]"></div>
                </>
              )}
              <div className="w-[48%] h-[98%] flex flex-col items-center gap-[2%]">
                <span className="textSemiBold text-[1.2vw] text-center  text-white">Certificate</span>
                <div className="w-full h-full flex flex-col items-center">
                  {selectedMemberData && selectedMemberData?.certificates ? (
                    (() => {
                      const certificates = typeof selectedMemberData.certificates === 'string'
                        ? JSON.parse(selectedMemberData.certificates) 
                        : selectedMemberData.certificates; 

                      return Object.entries(certificates).map(([key, value]) => (
                        <div key={key} className="w-[98%] h-[9%] flex flex-row items-center justify-between">
                          <span className="textSemiBold text-[1vw]  text-white">
                            {key.charAt(0).toUpperCase() + key.slice(1)} 
                          </span>
                          <div className="flex items-center gap-[2%] justify-end w-[40%]">
                            {isEditing && (
                              <div
                                onClick={() => handleToggleCertificate(key, !value)}
                                className={`w-[1vw] h-[1vw] rounded-full box-border flex items-center justify-center pb-[5%] cursor-pointer ${
                                  value ? 'bg-red-500' : 'bg-green-500'
                                } text-white`}
                              >
                                {value ? '-' : '+'}
                              </div>
                            )}
                            <span className="textSemiBold text-[#0080D0] text-[1vw]">
                              {typeof value === 'string' ? value : value ? 'DA' : 'NU'} 
                            </span>
                          </div>
                        </div>
                      ));
                    })()
                  ) : (
                    <div className="textMedium  text-white text-[1vw] w-full h-full flex items-center justify-center">
                      Nu ai niciun certificat.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <span className=" text-white textSemiBold text-[1vw] w-full text-center">Acțiuni HR / CONDUCERE</span>
            <div className="w-full h-[22%] flex flex-wrap flex-row gap-[1%] items-center justify-center">
              {isConducere ? (
                <>
                  <div
                    onClick={() => toggleEditMode(functiiShow === "PD" ? "pol" : functiiShow === "PEN" ? "pen" : "ac")}
                    className={`h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r ${
                      isEditing ? "from-[#2dd80f] to-[#22d60a]" : "from-[#D8630F] to-[#F59318]"
                    }`}
                  >
                    <span className="textBold text-white text-[.8vw]">
                      {isEditing ? "SALVEAZĂ MODIFICĂRILE" : "GESTIONEAZĂ ATRIBUTII/CERTIFICATE"}
                    </span>
                  </div>
                  <div onClick={handleOpenFWModal} className="h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.8vw]">FW</span>
                  </div>
                  <div onClick={handleOpenFineModal} className="h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.8vw]">AMENDĂ</span>
                  </div>
                  <div
                    onClick={handleOpenCooldownModal}
                    className={`h-[50%] px-[4%] ${
                      isEditing ? "mt-[0]" : "mt-[1%]"
                    } flex items-center justify-center rounded-[.2vw] bg-gradient-to-r from-[#D8630F] to-[#F59318] cursor-pointer`}
                  >
                    <span className="textBold text-white text-[.8vw]">COOLDOWN-URI</span>
                  </div>
                  <div onClick={() => checkPunishments(Number(selectedMemberData?.callsign), selectedMemberData?.discordID)} className="h-[50%] px-[4%] mt-[1%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                    <span className="textBold text-white text-[.8vw]">VERIFICĂ SANCȚIUNI</span>
                  </div>
                </>
              ) : isHR ? (
                <div
                  onClick={() => toggleEditMode(functiiShow === "PD" ? "pol" : functiiShow === "PEN" ? "pen" : "ac")}
                  className={`h-[50%] px-[4%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r ${
                    isEditing ? "from-[#2dd80f] to-[#22d60a]" : "from-[#D8630F] to-[#F59318]"
                  }`}
                >
                  <span className="textBold text-white text-[.8vw]">
                    {isEditing ? "SALVEAZĂ MODIFICĂRILE" : "GESTIONEAZĂ ATRIBUTII/CERTIFICATE"}
                  </span>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={upModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={upModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">UP MEMBRU</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={upMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">OFERĂ UP</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={upAPSModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={upAPSModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">UP AGENT-PAZA-SEF</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={() => upPen(3, "AGENT-PAZA-SEF")} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">OFERĂ UP</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={ACadetModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={ACadetModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">UP ACADEMIE - CADET</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu ID"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={upCadet} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">UP CADET</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={upDirectorModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={upDirectorModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">UP DIRECTOR-PENITENCIAR</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={() => upPen(1, "DIRECTOR-PENITENCIAR")} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">OFERĂ UP</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={academieModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={academieModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">TRIMITE LA ACADEMIE</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={sendAcademie} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">ACADEMIE</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={downAPModalOpen}
        onClose={handleUpModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={downAPModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">DOWN LA AGENT-PAZA</span>
          <input
            onChange={e => setUPCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={() => upPen(20, "AGENT-PAZA")} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">OFERĂ DOWN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={downModalOpen}
        onClose={handleDownModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={downModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">DOWN MEMBRU</span>
          <input
            onChange={e => setDOWNCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={downMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERĂ DOWN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={changeCallsignOpen}
        onClose={handleChangeCallsignModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={changeCallsignOpen}>
        <Box sx={changeCallsignStyle} className="flex flex-col items-center">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">SCHIMBĂ CALLSIGN</span>
          <input
            onChange={e => setOldCallsign(e.target.value)}
            placeholder="Introdu Callsign vechi"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setNewCallsign(e.target.value)}
            placeholder="Introdu Callsign nou"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={changeCallsign} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">SCHIMBĂ CALLSIGN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={changeGradeOpen}
        onClose={handleChangeGradeClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={changeGradeOpen}>
        <Box sx={changeCallsignStyle} className="flex flex-col items-center">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">SCHIMBĂ GRAD</span>
          <input
            onChange={e => setOldCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setNewGrade(e.target.value)}
            placeholder="Introdu Grad nou"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={changeGrade} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">SCHIMBĂ GRAD</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={adminModal}
        onClose={handleAdminModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={adminModal}>
        <Box sx={changeCallsignStyle} className="flex flex-col items-center">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">ADMIN RANK</span>
          <input
            onChange={e => setOldCallsign(e.target.value)}
            placeholder="Introdu Callsign"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setNewGrade(e.target.value)}
            placeholder="Introdu Admin Rank"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={() => changeAdminRank(changeRankType)} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">SETEAZĂ ADMIN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={penModalOpen}
        onClose={handlePenModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={penModalOpen}>
        <Box sx={upDownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">TRIMITE LA PENITENCIAR</span>
          <input
            onChange={e => setPenID(e.target.value)}
            placeholder="Introdu ID"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={sendPen} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span  className="text-white textBold text-[1.1vw]">TRIMITE LA PENITENCIAR</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={fwModalOpen}
        onClose={handleFWClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={fwModalOpen}>
        <Box sx={fwStyle} className="flex flex-col items-center">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">FW</span>
          <input
            onChange={e => setFWInput(e.target.value)}
            placeholder="Introdu motiv FW"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setFWDays(e.target.value)}
            placeholder="Durată expirare (-1 = permanent)"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={giveFW} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERĂ FW</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={fineModalOpen}
        onClose={handleFineClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
                timeout: 500,
            },
        }}
      >
        <Fade in={fineModalOpen}>
        <Box sx={changeCallsignStyle} className="flex flex-col items-center">
          <span className=" text-white textSemiBold text-[1vw] w-full text-center">AMENDĂ</span>
          <input
            onChange={e => setFineReason(e.target.value)}
            placeholder="Introdu motiv AMENDĂ"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setFineAmount(e.target.value)}
            placeholder="Introdu suma AMENDĂ"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={giveFine} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERĂ AMENDA</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={OpenDemiteModal}
        onClose={handleDemitereClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={OpenDemiteModal}>
        <Box sx={demisieStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">DEMITE MEMBRU</span>
          <input
            onChange={e => setDemiteCallsign(e.target.value)}
            placeholder="Introdu callsign (ex: 501)"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setDemiteDays(e.target.value)}
            placeholder="Câte zile trebuie să își ia ban?"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={outMember} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">DEMITE MEMBRU</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={cooldownModalOpen}
        onClose={handleCooldownModalClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={cooldownModalOpen}>
        <Box sx={cooldownStyle} className="flex flex-col items-center">
          <span className="text-white textSemiBold text-[1vw] w-full text-center">COOLDOWN TEST</span>
          <div className="w-[60%] h-[25%] flex flex-row items-center justify-center">
            <div className="w-[100%] h-[10%] mr-[5%] mt-[1%] flex flex-row items-center justify-center">
              <BpCheckbox
                checked={confiscatedCheck}
                onChange={() => setConfiscatedCheck(!confiscatedCheck)}
              />                
              <span className="textSemiBold text-white text-[1vw] h-full flex items-center">Confiscat</span>
            </div>
          </div>
          <input
            onChange={e => setCooldownType(e.target.value)}
            placeholder="Tip Test (radio, mdt, etc.)"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <input
            onChange={e => setCooldownDays(e.target.value)}
            placeholder="Zile Cooldown (inca nu e functional)"
            type="text"
            className="w-[60%] h-[25%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
          />
          <div onClick={setCooldown} className="cursor-pointer mt-[5%] w-[70%] h-[30%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
            <span className="text-white textBold text-[1.1vw]">OFERĂ COOLDOWN</span>
          </div>
        </Box>
        </Fade>
      </Modal>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  );
}

export default MembersPage;